module.exports = __webpack_public_path__ + "static/media/menu-centrocusto.ad0e63ce.svg";